import { z } from 'zod';

export type AIConstantShowModalFormValues = {
  code: string;
  value: string;
};

export const AIConstantShowModalFormSchema = z.object({
  code: z.string().min(1, 'Код не может быть пустым'),
  value: z.string().min(1, 'Значение константы не может быть пустым'),
});
